import React, { useState, useEffect, useRef } from 'react';
import Tooltip from '@mui/material/Tooltip';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Slider from '@mui/material/Slider';
import './StepContent.css';

// Tüm görselleri import et (Webpack build için gerekli)
import imgHareketliUykuPozisyonu from '../assets/hareketliuykupozisyonu.png';
import imgSirtUstuUykuPozisyonu from '../assets/sirtustuuykupozisyonu.png';
import imgYanUykuPozisyonu from '../assets/yanuykupozisyonu.png';
import imgYuzUstuUykuPozisyonu from '../assets/yuzustuuykupozisyonu.png';
import imgGeneldeOrtaTempoda from '../assets/geneldeortatempoda,dengelibirgunumoluyor..png';
import imgOldukcaSakinBirTempom from '../assets/oldukcasakinbirtempomvar..png';
import imgYoguntempoluBirGun from '../assets/yoguntempolubirgungeciriyorum..png';
import imgHicbirProblemYasamiyorum from '../assets/hicbirproblemyasamiyorum,sabahlaridinlenmisuyaniyorum..png';
import imgNefesAlmaktaZorlaniyorum from '../assets/nefesalmaktazorlaniyorum,zamanzamanhorlamaproblemiyasiyorum.png';
import imgRefluNedeniyle from '../assets/reflunedeniylegecelerisiksikuyaniyorum..png';
import imgUykumTerlemeNedeniyle from '../assets/uykumterlemenedeniylebolunuyor..png';
import imgSadecebelAgrisi from '../assets/sadecebelagrisi.png';
import imgSadeceBoyunAgrisi from '../assets/sadeceboyunagrisi.png';
import imgSadeceOmuzAgrisi from '../assets/sadeceomuzagrisi.png';
import imgHepsi from '../assets/hepsi.png';
import imgHicbirAgriHissetmiyorum from '../assets/hicbiragrihissetmiyorum.png';
import imgEvetButurDogalMalzemelere from '../assets/evet,buturdogalmalzemelerekarsialerjim,hassasiyetimvar.png';
import imgHayirYok from '../assets/hayir,yok.png';
import imgYumusak from '../assets/yumusak.png';
import imgOrta from '../assets/orta.png';
import imgSert from '../assets/sert.png';
import imgYukseklikAlcak from '../assets/yukseklikalcak.png';
import imgYukseklikOrta from '../assets/yukseklikorta.png';
import imgYukseklikYuksek from '../assets/yukseklikyuksek.png';
import imgYumusakYatak from '../assets/yumusakyatak.png';
import imgOrtaSertYatak from '../assets/orta-sertyatak.png';
import imgSertYatak from '../assets/sertyatak.png';

// Görsel mapping objesi
const IMAGE_MAP = {
  // Uyku pozisyonları
  'hareketliuykupozisyonu': imgHareketliUykuPozisyonu,
  'sirtustuuykupozisyonu': imgSirtUstuUykuPozisyonu,
  'yanuykupozisyonu': imgYanUykuPozisyonu,
  'yuzustuuykupozisyonu': imgYuzUstuUykuPozisyonu,
  // Tempo
  'geneldeortatempoda,dengelibirgunumoluyor.': imgGeneldeOrtaTempoda,
  'oldukcasakinbirtempomvar.': imgOldukcaSakinBirTempom,
  'yoguntempolubirgungeciriyorum.': imgYoguntempoluBirGun,
  // Uyku düzeni
  'hicbirproblemyasamiyorum,sabahlaridinlenmisuyaniyorum.': imgHicbirProblemYasamiyorum,
  'nefesalmaktazorlaniyorum,zamanzamanhorlamaproblemiyasiyorum': imgNefesAlmaktaZorlaniyorum,
  'reflunedeniylegecelerisiksikuyaniyorum.': imgRefluNedeniyle,
  'uykumterlemenedeniylebolunuyor.': imgUykumTerlemeNedeniyle,
  // Ağrı bölgeleri
  'sadecebelagrisi': imgSadecebelAgrisi,
  'sadeceboyunagrisi': imgSadeceBoyunAgrisi,
  'sadeceomuzagrisi': imgSadeceOmuzAgrisi,
  'hepsi': imgHepsi,
  'hicbiragrihissetmiyorum': imgHicbirAgriHissetmiyorum,
  // Doğal malzeme
  'evet,buturdogalmalzemelerekarsialerjim,hassasiyetimvar': imgEvetButurDogalMalzemelere,
  'hayir,yok': imgHayirYok,
  // Yastık sertliği
  'yumusak': imgYumusak,
  'orta': imgOrta,
  'sert': imgSert,
  // Yastık yüksekliği
  'yukseklikalcak': imgYukseklikAlcak,
  'yukseklikorta': imgYukseklikOrta,
  'yukseklikyuksek': imgYukseklikYuksek,
  // Yatak sertliği
  'yumusakyatak': imgYumusakYatak,
  'orta-sertyatak': imgOrtaSertYatak,
  'sertyatak': imgSertYatak
};

const minBoy = 120, maxBoy = 220;
const minKilo = 30, maxKilo = 220;
const yasOptions = Array.from({ length: 67 }, (_, i) => i.toString()).concat('65+');

function VKIBar({ vki }) {
  const min = 10, max = 40;
  let percent = 0;
  if (vki) {
    percent = Math.min(100, Math.max(0, ((vki - min) / (max - min)) * 100));
  }
  return (
    <div className="vki-bar-container">
      <div className="vki-bar-bg">
        <div className="vki-bar-indicator" style={{ left: `calc(${percent}% - 10px)` }} />
      </div>
    </div>
  );
}

const StepContent = ({ question, answer, onAnswerChange, answers }) => {
  // Tüm hook'lar en başta, koşulsuz
  const [localAge, setLocalAge] = useState('0');
  const [localHeight, setLocalHeight] = useState(minBoy);
  const [localWeight, setLocalWeight] = useState(minKilo);
  const [bmiValue, setBmiValue] = useState('');
  const [vkiInfoOpen, setVkiInfoOpen] = useState(false);
  const isFirstMount = useRef(true);

  useEffect(() => {
    if (question.type === 'bmi_age' && answer && isFirstMount.current) {
      setLocalAge(answer.yas || '0');
      setLocalHeight(Number(answer?.boy) || minBoy);
      setLocalWeight(Number(answer?.kilo) || minKilo);
      isFirstMount.current = false;
    }
  }, []);

  useEffect(() => {
    if (question.type === 'bmi_age') {
      let vki = '';
      let vkiKategori = '';
      let yasKategori = '';
      let yasNumeric = null;
      if (localAge && !isNaN(Number(localAge))) {
        yasNumeric = Number(localAge);
      } else if (localAge === '65+') {
        yasNumeric = 65;
      }
      // Yaş kategorisini belirle
      if (localAge !== '' && yasNumeric !== null) {
        if (yasNumeric <= 7) {
          yasKategori = '0-7';
          vkiKategori = 'Zayıf'; // 0-7 yaş için otomatik Zayıf
        } else {
          yasKategori = '7+';
        }
      }
      // VKI hesapla (her yaş için)
      if (localAge !== '' && yasNumeric !== null && localHeight > 0 && localWeight > 0) {
        const vkiHesaplanan = (localWeight / ((localHeight / 100) ** 2));
        vki = vkiHesaplanan.toFixed(1); // vki_sayisal için her zaman sayısal değer
        if (yasNumeric > 7) {
          setBmiValue(vki);
          if (vkiHesaplanan < 18.5) {
            vkiKategori = 'Zayıf';
          } else if (vkiHesaplanan < 25) {
            vkiKategori = 'Orta';
          } else {
            vkiKategori = 'Kilolu';
          }
        } else {
          setBmiValue(''); // 0-7 yaş için VKI gösterilmez
        }
      } else {
      setBmiValue('');
      }
      // Yeni cevapları oluştur
      const newBmiAge = {
        yas_gercek: localAge,
        boy: localHeight,
        kilo: localWeight,
        vki: vkiKategori,
        vki_sayisal: vki
      };
      // Eğer cevap değiştiyse güncelle
      if (JSON.stringify(answer) !== JSON.stringify(newBmiAge)) {
        onAnswerChange(question.id, newBmiAge);
      }
      // Kategoriler için de aynı kontrol
      if (yasKategori && answers.yas !== yasKategori) {
        onAnswerChange('yas', yasKategori);
      }
      if (vkiKategori && answers.bmi !== vkiKategori) {
        onAnswerChange('bmi', vkiKategori);
      }
    }
  }, [localAge, localHeight, localWeight, question.id, onAnswerChange, question.type, answer, answers, bmiValue]);

  // Yaş 7'den küçükse boy ve kilo değerlerini resetle
  useEffect(() => {
    if (question.id === 'bmi_age' && localAge !== '' && Number(localAge) <= 7) {
      if (localHeight !== minBoy) setLocalHeight(minBoy);
      if (localWeight !== minKilo) setLocalWeight(minKilo);
    }
  }, [localAge, question.id]);

  // bmi_age tipi için özel render
  if (question.id === 'bmi_age') {
      return (
    <>
      <div className="step-content-header">
      <h2 className="step-question-title">{question.question}</h2>
      <hr className="content-divider" />
      </div>
        {/* Yaş, Boy, Kilo Container */}
        <div className="bmi-input-container">
          <div className="bmi-row-modern" style={{ marginBottom: '4px' }}>
            <label htmlFor="yas-input">Yaşınız:</label>
            <div className="bmi-value-group">
              <input 
                id="yas-input"
                type="number"
                className="bmi-value-box" 
                value={localAge === 65 ? '65' : localAge} 
                onChange={(e) => {
                  const val = e.target.value;
                  if (val === '') {
                    setLocalAge('0');
                  } else {
                    const num = Math.min(65, Math.max(0, parseInt(val) || 0));
                    setLocalAge(num);
                  }
                }}
                min={0}
                max={65}
              />
              <span className="bmi-unit">yaş</span>
            </div>
          </div>
          <Slider
            id="yas-slider"
            min={0}
            max={65}
            step={1}
            value={Number(localAge)}
            onChange={(_, v) => setLocalAge(Number(v))}
            className="MuiSlider-root"
          />
          
          <div className="bmi-row-modern" style={{ marginBottom: '4px' }}>
            <label htmlFor="boy-input">Boyunuz:</label>
            <div className="bmi-value-group">
              <input 
                id="boy-input"
                type="number"
                className={`bmi-value-box${localAge !== '' && Number(localAge) <= 7 ? ' bmi-disabled' : ''}`} 
                value={localHeight}
                onChange={(e) => {
                  const val = e.target.value;
                  if (val === '') {
                    setLocalHeight(minBoy);
                  } else {
                    const num = Math.min(maxBoy, Math.max(minBoy, parseInt(val) || minBoy));
                    setLocalHeight(num);
                  }
                }}
                disabled={localAge !== '' && Number(localAge) <= 7}
                min={minBoy}
                max={maxBoy}
              />
              <span className="bmi-unit">cm</span>
            </div>
          </div>
          <Slider
            id="boy-slider"
            min={minBoy}
            max={maxBoy}
            value={Number(localHeight)}
            onChange={(_, v) => setLocalHeight(Number(v))}
            className={`MuiSlider-root${localAge !== '' && Number(localAge) <= 7 ? ' bmi-disabled-slider' : ''}`}
            disabled={localAge !== '' && Number(localAge) <= 7}
          />
          
          <div className="bmi-row-modern" style={{ marginBottom: '4px' }}>
            <label htmlFor="kilo-input">Kilonuz:</label>
            <div className="bmi-value-group">
              <input 
                id="kilo-input"
                type="number"
                className={`bmi-value-box${localAge !== '' && Number(localAge) <= 7 ? ' bmi-disabled' : ''}`} 
                value={localWeight}
                onChange={(e) => {
                  const val = e.target.value;
                  if (val === '') {
                    setLocalWeight(minKilo);
                  } else {
                    const num = Math.min(maxKilo, Math.max(minKilo, parseInt(val) || minKilo));
                    setLocalWeight(num);
                  }
                }}
                disabled={localAge !== '' && Number(localAge) <= 7}
                min={minKilo}
                max={maxKilo}
              />
              <span className="bmi-unit">kg</span>
            </div>
          </div>
          <Slider
            id="kilo-slider"
            min={minKilo}
            max={maxKilo}
            value={localWeight}
            onChange={(_, v) => setLocalWeight(v)}
            className={`MuiSlider-root${localAge !== '' && Number(localAge) <= 7 ? ' bmi-disabled-slider' : ''}`}
            disabled={localAge !== '' && Number(localAge) <= 7}
          />
        </div>

        {/* VKI Container */}
        <div className="vki-container">
          {localAge !== '' && Number(localAge) <= 7 ? (
            <span className="bmi-warning">0-7 yaş arası için VKI değeri hesaplanamaz.</span>
          ) : (
            <div className="vki-content-wrapper">
              <VKIBar vki={bmiValue} />
              {bmiValue && (
                <div className="vki-value" style={{ display: 'flex', alignItems: 'center', gap: 10, whiteSpace: 'nowrap' }}>
                  <ClickAwayListener onClickAway={() => setVkiInfoOpen(false)}>
                  <Tooltip
                    title={'VKİ (Vücut Kitle İndeksi), kilonuzun boyunuza oranıdır. Referans: 18.5 altı Zayıf, 18.5–24.9 Orta, 25 ve üzeri Kilolu.'}
                    placement="top"
                    arrow
                    open={vkiInfoOpen}
                    onClose={() => setVkiInfoOpen(false)}
                    disableHoverListener
                    disableFocusListener
                    disableTouchListener
                  >
                    <span
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: 24,
                        height: 24,
                        borderRadius: '50%',
                        background: '#e3f2fd',
                        color: '#1976d2',
                        fontSize: 18,
                        fontWeight: 700,
                        cursor: 'help'
                      }}
                      onMouseEnter={() => setVkiInfoOpen(true)}
                      onMouseLeave={() => setVkiInfoOpen(false)}
                      onFocus={() => setVkiInfoOpen(true)}
                      onBlur={() => setVkiInfoOpen(false)}
                      onClick={(e) => { e.stopPropagation(); setVkiInfoOpen(prev => !prev); }}
                      onTouchEnd={(e) => { e.preventDefault(); e.stopPropagation(); setVkiInfoOpen(prev => !prev); }}
                      onClickCapture={(e) => e.stopPropagation()}
                      role="button"
                      aria-label="VKI bilgisi"
                    >
                      ?
                    </span>
                  </Tooltip>
                  </ClickAwayListener>
                  Vücut Kitle İndeksi:
                  <span className="vki-value-box">{bmiValue}</span>
                </div>
              )}
            </div>
          )}
        </div>
      </>
    );
  }

  // Diğer soru tipleri için eski render
  const handleOptionClick = (option) => {
    
    if (question.id === 'uyku_pozisyonu') {
      const current = Array.isArray(answer) ? answer : [];
      
      // Eğer Hareketli Uyku Pozisyonu seçildiyse, sadece onu seçili yap
      if (option === 'Hareketli Uyku Pozisyonu') {
        const newAnswer = current.includes(option) ? [] : ['Hareketli Uyku Pozisyonu'];
        onAnswerChange(question.id, newAnswer);
        return;
      }
      // Diğerlerinden biri seçildiyse, Hareketli Uyku Pozisyonu kaldır ve klasik checkbox mantığı uygula
      let newAnswer = current.includes(option)
        ? current.filter(opt => opt !== option)
        : [...current.filter(opt => opt !== 'Hareketli Uyku Pozisyonu'), option];
      onAnswerChange(question.id, newAnswer);
      return;
    }
    onAnswerChange(question.id, option);
  };

  /*const handleCheckboxChange = (option) => {
    const currentAnswer = Array.isArray(answer) ? answer : [];
    const newAnswer = currentAnswer.includes(option)
      ? currentAnswer.filter(opt => opt !== option)
      : [...currentAnswer, option];
    onAnswerChange(question.id, newAnswer);
  };*/


  const isOptionSelected = (option) => {
    if (question.type === 'radio') {
      return answer === option;
    } else {
      const currentAnswer = answer || [];
      if (!Array.isArray(currentAnswer)) return false;

      if (option === 'Hepsi') {
        // Hepsi seçili sayılması için: tüm normal seçenekler seçiliyse
        const normalOptions = question.options.filter(opt => !['Hepsi', 'Hiçbir ağrı hissetmiyorum', 'Hareketli Uyku Pozisyonu'].includes(opt));
        return normalOptions.length > 0 && normalOptions.every(opt => currentAnswer.includes(opt));
      }
      return currentAnswer.includes(option);
    }
  };

  const isTwoOptions = question.options && question.options.length === 2 && !question.options.includes('Hepsi') && !question.options.includes('HİSSETMİYORUM');

  

  return (
          <>
        <div className="step-content-header">
        <h2 className="step-question-title">{question.question}</h2>
        <hr className="content-divider" />
        </div>
      <div className="step-content-actions">
      <div className={`options-container ${isTwoOptions ? 'two-options' : ''} ${question.type === 'checkbox' ? 'checkbox-options' : ''}`}>
        {question.options && question.options.map((option, index) => {
          // İdeal sertlik sorusu için sadece temel seçenekleri göster ("Yastık" ekini temizle)
          if (question.id === 'ideal_sertlik') {
            const base = option.replace(/\s*yastık$/i, '');
            if (!['Yumuşak', 'Orta-Sert', 'Sert'].includes(base)) {
              return null;
            }
          }
          
          // Option metnini dosya adına çevir
          const getImageSrc = (option) => {
            // Yastık yüksekliği için özel dosya adları kullan
            if (question.id === 'yastik_yukseklik') {
              const map = {
                'Alçak': 'yukseklikalcak',
                'Orta': 'yukseklikorta',
                'Yüksek': 'yukseklikyuksek'
              };
              const key = map[option] || 'yukseklikorta';
              return IMAGE_MAP[key] || IMAGE_MAP['yukseklikorta'];
            }
            
            // Yatak sertliği için özel dosya adları kullan
            if (question.id === 'sertlik') {
              const map = {
                'Yumuşak Yatak': 'yumusakyatak',
                'Orta-Sert Yatak': 'orta-sertyatak',
                'Sert Yatak': 'sertyatak'
              };
              const key = map[option];
              if (key && IMAGE_MAP[key]) {
                return IMAGE_MAP[key];
              }
            }
            
            // "Yastık" ekini temizle ve görsel eşleştirmesi yap
            const noSuffix = option.replace(/\s*yastık$/i, '');
            const mapped = noSuffix === 'Orta-Sert' ? 'Orta' : noSuffix;
            const key = mapped
              .toLowerCase()
              .replace(/ /g, '')
              .replace(/ı/g, 'i')
              .replace(/ü/g, 'u')
              .replace(/ş/g, 's')
              .replace(/ö/g, 'o')
              .replace(/ç/g, 'c')
              .replace(/ğ/g, 'g')
              .replace(/İ/g, 'i')
              .replace(/Ü/g, 'u')
              .replace(/Ş/g, 's')
              .replace(/Ö/g, 'o')
              .replace(/Ç/g, 'c')
              .replace(/Ğ/g, 'g');
            
            return IMAGE_MAP[key] || require(`../assets/${key}.png`);
          };
          return (
            <div
              key={index}
              className={`option-item ${isOptionSelected(option) ? 'selected' : ''}`}
              onClick={() => handleOptionClick(option)}
              style={{
                pointerEvents: 'auto',
                opacity: 1
              }}
            >
              {/* Option görseli */}
              <div className={`option-image-wrapper`}>
                <div className={`option-image-border${isOptionSelected(option) ? ' selected' : ''}`}>
                  <img
                    src={getImageSrc(option)}
                    alt={option}
                    className="option-image"
                    style={{ width: 150, height: 280, objectFit: 'contain', marginBottom: 8, display: 'block', marginLeft: 'auto', marginRight: 'auto' }}
                  />
                </div>
              </div>
              <span className="option-text">{option}</span>
            </div>
          );
        })}
        </div>
        <div className="form-navigation">
          <div className="form-nav-right">
          </div>
        </div>
      </div>
    </>
  );
};

export default StepContent; 